<template>
  <div class="page-listing">
     <router-link to="/" class="btn-back"><span>Back to Dashboard</span></router-link>
    <h1 class="h2 mb-3">Edit My Listing</h1>
    <div v-if="loading">{{ loadingMessage }}<b-icon icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon></div>
    <div v-else-if="saved">
      Successfully saved your listing! <a href="/listings">Back to My Listings</a>
    </div>
    <div v-else>
      <!--<a target="_blank" class="view-listing-link" :href="`https://gocampingamerica.com/parks/${this.slug}`">View My Listing</a>-->
      <a target="_blank" class="view-listing-link" :href="`https://gocampingamerica.com/?rdr=${$route.params.id}`">View My Listing</a>
      <b-form @submit="onSubmit" @reset="onReset" v-if="show && !saving">

        <b-card bg-variant="light" class="mb-3" header="Basic Info">
          <b-form-group
            label-cols-sm="3"
            label="Listing Name:"
            label-align-sm="right"
          >
            <b-form-input id="nested-street" required v-model="form.Park_Listing_Name__c"></b-form-input>
          </b-form-group>

          <b-form-group
            label-cols-sm="3"
            label="Published?"
            label-align-sm="right"
          >
            <b-form-checkbox v-model="form.Is_Published__c" ></b-form-checkbox>
          </b-form-group>

          <b-form-group
            label-cols-sm="3"
            label="Website:"
            label-align-sm="right"
            description="We'll show this as a 'View Website' button on your listing."
          >
            <b-input-group>
              <b-input-group-prepend is-text>
                <b-icon-link45deg></b-icon-link45deg>
              </b-input-group-prepend>
              <b-form-input id="nested-street" @blur.native="checkUrl('Account_Website__c')" type="url" v-model="form.Account_Website__c"></b-form-input>
            </b-input-group>
          </b-form-group>

          <b-form-group
            label-cols-sm="3"
            label="Reservation Link:"
            label-align-sm="right"
            description="We'll show this as a 'Make a Reservation' button on your listing.
              You can leave it blank if you don't take online reservations or if this link
              is the same as your website link."
          >
            <b-input-group>
              <b-input-group-prepend is-text>
                <b-icon-link45deg></b-icon-link45deg>
              </b-input-group-prepend>
              <b-form-input id="nested-street" @blur.native="checkUrl('Booking_Link__c')" v-model="form.Booking_Link__c"></b-form-input>
            </b-input-group>
          </b-form-group>

          <b-form-group
            label-cols-sm="3"
            label="Open Year Round?"
            label-align-sm="right"
          >
            <b-form-checkbox v-model="form.Open_All_Year__c" ></b-form-checkbox>
          </b-form-group>

          <div v-if="!form.Open_All_Year__c">
            <b-form-group
              label-cols-sm="3"
              label="Open Month:"
              label-align-sm="right"
            >
              <b-input-group>
                <multiselect v-model="form.Open_Month__c" :multiple="false"
                  :options="picklists.Open_Month__c" label="label" track-by="value"></multiselect>
              </b-input-group>
            </b-form-group>
            <b-form-group
              label-cols-sm="3"
              label="Open Day:"
              label-align-sm="right"
            >
              <b-input-group>
                <multiselect v-model="form.Open_Day__c" :multiple="false"
                  :options="picklists.Open_Day__c" label="value" track-by="value"></multiselect>
              </b-input-group>
            </b-form-group>
            <b-form-group
              label-cols-sm="3"
              label="Close Month:"
              label-align-sm="right"
            >
              <b-input-group>
                <multiselect v-model="form.Close_Month__c" :multiple="false"
                  :options="picklists.Close_Month__c" label="label" track-by="value"></multiselect>
              </b-input-group>
            </b-form-group>
            <b-form-group
              label-cols-sm="3"
              label="Close Day:"
              label-align-sm="right"
            >
              <b-input-group>
                <multiselect v-model="form.Close_Day__c" :multiple="false"
                  :options="picklists.Close_Day__c" label="label" track-by="value"></multiselect>
              </b-input-group>
            </b-form-group>
          </div>

          <b-form-group
            v-if="form.Park_Description__c !== null"
            label="Park Description"
          >
            <quill ref="quill_Park_Description__c" output="html"
              :config="quillOptions"
              v-model="form.Park_Description__c"></quill>
              <p>
                <small>Length: {{ getProgressLabel(form.Park_Description__c.length, 450, 600) }}</small>
                <b-progress max="450">
                  <b-progress-bar :value="form.Park_Description__c.length"
                    :variant="getProgressVariant(form.Park_Description__c.length, 450, 600)">
                  </b-progress-bar>
                </b-progress>
              </p>
          </b-form-group>
        </b-card>

        <b-card bg-variant="light" class="mb-3" header="Location">
            <b-form-group
              label-cols-sm="3"
              label="Street Address:"
              label-align-sm="right"
            >
              <b-form-input id="nested-street" v-model="form.Account_Org_Address__c"></b-form-input>
            </b-form-group>

            <b-form-group
              label-cols-sm="3"
              label="City:"
              label-align-sm="right"
            >
              <b-form-input id="nested-city" v-model="form.Account_Org_City__c"></b-form-input>
            </b-form-group>

            <b-form-group
              label-cols-sm="3"
              label="State / Province:"
              label-align-sm="right"
            >
              <b-form-input id="nested-state" v-model="form.Account_Org_State__c"></b-form-input>
            </b-form-group>

            <b-form-group
              label-cols-sm="3"
              label="Zip / Postal:"
              label-align-sm="right"
            >
              <b-form-input id="nested-state"
                v-model="form.Account_Org_Zip_Postal__c"></b-form-input>
            </b-form-group>

            <b-form-group
              label-cols-sm="3"
              label="Country:"
              label-align-sm="right" class="mb-0"
            >
              <b-form-radio-group
                class="pt-2 pb-4"
                v-model="form.Account_Org_Country__c"
                :options="['United States', 'Canada']"
              ></b-form-radio-group>
            </b-form-group>

            <b-form-group
              label-cols-sm="3"
              label="Latitude:"
              label-align-sm="right"
            >
              <b-form-input id="nested-state"
                v-model="form.Park_Lat_Long__c.latitude"></b-form-input>
            </b-form-group>

            <b-form-group
              label-cols-sm="3"
              label="Longitude:"
              label-align-sm="right"
              description="We use these coordinates to make sure
                the map image on your listing is positioned perfectly!"
            >
              <b-form-input id="nested-state" v-model="form.Park_Lat_Long__c.longitude">
              </b-form-input>
            </b-form-group>
        </b-card>

        <b-card bg-variant="light" class="mb-3" header="Features">
          <b-form-group
              label-cols-sm="3"
              label="Extended Stay?"
              label-align-sm="right"
              description="Does your park offer Extended Stay options?"
            >
              <b-form-checkbox v-model="form.Extended_Stay__c" ></b-form-checkbox>
          </b-form-group>

          <b-form-group
              label-cols-sm="3"
              label="Site Options"
              label-align-sm="right"
              description="Select all that apply."
            >
            <multiselect v-model="form.Site_Options__c" :multiple="true"
              :options="picklists.Site_Options__c" label="label" track-by="value"></multiselect>
          </b-form-group>

          <b-form-group
              label-cols-sm="3"
              label="Services"
              label-align-sm="right"
              description="Select all that apply."
            >
            <multiselect v-model="form.Services__c" :multiple="true"
              :options="picklists.Services__c" label="label" track-by="value"></multiselect>
          </b-form-group>

          <b-form-group
              label-cols-sm="3"
              label="Recreation"
              label-align-sm="right"
              description="Select all that apply."
            >
            <multiselect v-model="form.Recreation__c" :multiple="true"
              :options="picklists.Recreation__c" label="label" track-by="value"></multiselect>
          </b-form-group>

          <b-form-group
              label-cols-sm="3"
              label="Amenities"
              label-align-sm="right"
              description="Select all that apply."
            >
            <multiselect v-model="form.Amenities__c" :multiple="true"
              :options="picklists.Amenities__c" label="label" track-by="value"></multiselect>
          </b-form-group>

          <b-form-group
              label-cols-sm="3"
              label="Lifestyles"
              label-align-sm="right"
              description="Select all that apply."
            >
            <multiselect v-model="form.Lifestyles__c" :multiple="true"
              :options="picklists.Lifestyles__c" label="label" track-by="value"></multiselect>
          </b-form-group>

          <b-form-group
              label-cols-sm="3"
              label="Clubs / Affiliations"
              label-align-sm="right"
              description="Select all that apply."
            >
            <multiselect v-model="form.Clubs_Discounts__c" :multiple="true"
              :options="picklists.Clubs_Discounts__c" label="label" track-by="value"></multiselect>
          </b-form-group>

          <b-form-group
              label-cols-sm="3"
              label="Discounts"
              label-align-sm="right"
              description="Select all that apply."
            >
            <multiselect v-model="form.Discounts__c" :multiple="true"
              :options="picklists.Discounts__c" label="label" track-by="value"></multiselect>
          </b-form-group>
        </b-card>

        <b-card bg-variant="light" class="mb-3" header="Extended Info">
            <b-form-group
              v-if="form.Local_Points_of_Interest__c !== null"
              label="Local Points of Interest"
              description="List any nearby attractions or interest points:
                historic sites, recreation, shopping, etc."
            >
              <quill output="html" v-model="form.Local_Points_of_Interest__c" :config="quillOptions"></quill>
            </b-form-group>
            <b-form-group
              v-if="form.Directions_to_Park__c !== null"
              label="Directions to Park"
              description="For parks off the beaten path, Google Maps might
                not be enough to get your guests to you. If the address you
                listed above takes you to the right place, just leave this blank.
                Otherwise give clear directions from the nearest interstate or
                major highway."
            >
              <quill v-model="form.Directions_to_Park__c" output="html" :config="quillOptions"></quill>
            </b-form-group>
            <b-form-group
              v-if="form.Park_Rules__c !== null"
              label="Park Rules"
              description="List any relevant rules here: Adults only, no liquor, quiet times etc."
            >
              <quill v-model="form.Park_Rules__c" output="html" :config="quillOptions"></quill>
            </b-form-group>
            <b-form-group
              v-if="form.Rates__c !== null"
              label="Park Rates"
              description="You can list rates here or refer visitors to your website."
            >
              <quill v-model="form.Rates__c" output="html" :config="quillOptions"></quill>
            </b-form-group>
        </b-card>

        <b-card bg-variant="light" class="mb-3" header="Social and Links">
            <b-form-group
              label-cols-sm="3"
              label="Facebook Link:"
              label-align-sm="right"
            >
              <b-input-group>
                <b-input-group-prepend is-text>
                  <b-icon-link45deg></b-icon-link45deg>
                </b-input-group-prepend>
                <b-form-input id="nested-street" type="url" @blur.native="checkUrl('Facebook_Page__c')" v-model="form.Facebook_Page__c"></b-form-input>
              </b-input-group>
            </b-form-group>

            <b-form-group
              label-cols-sm="3"
              label="Instagram Link:"
              label-align-sm="right"
            >
              <b-input-group>
                <b-input-group-prepend is-text>
                  <b-icon-link45deg></b-icon-link45deg>
                </b-input-group-prepend>
                <b-form-input id="nested-street" type="url" @blur.native="checkUrl('Instagram_URL__c')" v-model="form.Instagram_URL__c"></b-form-input>
              </b-input-group>
            </b-form-group>

            <b-form-group
              label-cols-sm="3"
              label="Trip Advisor Link:"
              label-align-sm="right"
            >
              <b-input-group>
                <b-input-group-prepend is-text>
                  <b-icon-link45deg></b-icon-link45deg>
                </b-input-group-prepend>
                <b-form-input id="nested-street" type="url" @blur.native="checkUrl('Trip_Advisor__c')" v-model="form.Trip_Advisor__c"></b-form-input>
              </b-input-group>
            </b-form-group>

            <b-form-group
              label-cols-sm="3"
              label="Twitter Link:"
              label-align-sm="right"
            >
              <b-input-group>
                <b-input-group-prepend is-text>
                  <b-icon-link45deg></b-icon-link45deg>
                </b-input-group-prepend>
                <b-form-input id="nested-street" type="url" @blur.native="checkUrl('Twitter_Page__c')" v-model="form.Twitter_Page__c"></b-form-input>
              </b-input-group>
            </b-form-group>

            <b-form-group
              label-cols-sm="3"
              label="Yelp Link:"
              label-align-sm="right"
            >
              <b-input-group>
                <b-input-group-prepend is-text>
                  <b-icon-link45deg></b-icon-link45deg>
                </b-input-group-prepend>
                <b-form-input id="nested-street" type="url" @blur.native="checkUrl('Yelp__c')" v-model="form.Yelp__c"></b-form-input>
              </b-input-group>
            </b-form-group>

            <b-form-group
              label-cols-sm="3"
              label="YouTube Link:"
              label-align-sm="right"
            >
              <b-input-group>
                <b-input-group-prepend is-text>
                  <b-icon-link45deg></b-icon-link45deg>
                </b-input-group-prepend>
                <b-form-input id="nested-street" type="url" @blur.native="checkUrl('You_Tube__c')" v-model="form.You_Tube__c"></b-form-input>
              </b-input-group>
            </b-form-group>
        </b-card>

        <b-card bg-variant="light" class="mb-3" header="Images ">
          <ImageManager v-if="form.Id !== null" :listingId="form.Id" :images="images" :setImages="setImages"></ImageManager>
        </b-card>

        <div class="text-right pb-5">
          <b-button type="submit" variant="primary" class="fr">Save Listing</b-button>
          <!--<b-button type="reset" variant="danger">Reset</b-button>-->
        </div>
      </b-form>
      <b-card class="mt-3 dev-only" header="Form Data Result">
        <pre class="m-0">{{ form }}</pre>
      </b-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Multiselect from 'vue-multiselect';
import ImageManager from '../components/ImageManager.vue';

axios.defaults.withCredentials = true;
const server = process.env.VUE_APP_API_URL;

export default {
  name: 'Listing',
  components: {
    Multiselect,
    ImageManager,
  },
  data() {
    return {
      loading: true,
      saving: false,
      saved: false,
      loadingMessage: 'Loading... Please Wait...',
      slug: null,
      listingcid: null,
      newgcurl: null,
      images: [],
      quillOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // toggled buttons
            ['link'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
            [{ align: [] }],

            ['clean'], // remove formatting button
          ],
        },
      },
      form: {
        // Basic Info
        Park_Listing_Name__c: null,
        Is_Published__c: null,
        Account_Website__c: null,
        Booking_Link__c: null,
        Open_All_Year__c: null,
        Open_Day__c: null,
        Open_Month__c: null,
        Close_Day__c: null,
        Close_Month__c: null,
        Park_Description__c: null,
        New_GCA_URL__c: null,

        // Location
        Account_Org_Address__c: null,
        Account_Org_City__c: null,
        Account_Org_Country__c: null,
        Account_Org_State__c: null,
        Account_Org_Zip_Postal__c: null,
        Park_Lat_Long__c: {
          latitude: null,
          longitude: null,
        },

        // Extended Info
        Directions_to_Park__c: null,
        Local_Points_of_Interest__c: null,
        Park_Rules__c: null,
        Rates__c: null,

        // Features
        Extended_Stay__c: null,
        Services__c: null,
        Site_Options__c: null,
        Amenities__c: null,
        Discounts__c: null,
        Clubs_Discounts__c: null,
        Lifestyles__c: null,
        Recreation__c: null,

        // Social and Links
        Facebook_Page__c: null,
        Instagram_URL__c: null,
        Trip_Advisor__c: null,
        Twitter_Page__c: null,
        Yelp__c: null,
        You_Tube__c: null,

        // Unused for now...
        Park_Overview__c: null,
        Park_Classification__c: null,
        Park_Phone__c: null,
        Park_Public_Email__c: null,
        Toll_Free_Phone__c: null,
      },
      picklists: {},
      show: true,
    };
  },
  methods: {
    setImages(images) {
      this.images = images;
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.images.length; i++) {
        this.images[i].order = i;
      }
    },
    checkUrl(itemRef) {
      if (this.form[itemRef] && !this.form[itemRef].startsWith('http')) {
        this.form[itemRef] = `http://${this.form[itemRef]}`;
      }
    },
    getProgressLabel(currentLength, goodLength, maxLength) {
      if (currentLength <= 8) {
        return '';
      }
      if (currentLength > maxLength) {
        return 'Too Long';
      }
      if (currentLength < goodLength / 2) {
        return 'Too Short';
      }
      if (currentLength < goodLength) {
        return 'Almost There!';
      }
      return 'Just Right.';
    },
    getProgressVariant(currentLength, goodLength, maxLength) {
      if (currentLength > maxLength) {
        return 'danger';
      }
      if (currentLength < goodLength / 2) {
        return 'danger';
      }
      if (currentLength < goodLength) {
        return 'primary';
      }
      return 'success';
    },
    genForm() {
      const form = JSON.parse(JSON.stringify(this.form));
      Object.keys(form).forEach((key) => {
        if (form[key] && form[key][0] && form[key][0].value) {
          form[key] = form[key].map((x) => x.value);
        }
        if (form[key] && form[key].value) {
          form[key] = form[key].value;
        }
      });

      // The single-select still presents options as arrays (sometimes) so we need to strip that
      // down and present a single-element array to salesforce
      const makeSingleThings = ['Open_Day__c', 'Close_Day__c', 'Open_Month__c', 'Close_Month__c'];
      // eslint-disable-next-line no-restricted-syntax
      for (const k of makeSingleThings) {
        if (!k) {
          // eslint-disable-next-line no-continue
          continue;
        }

        if (Array.isArray(form[k])) {
          form[k] = [form[k][0]];
        } else {
          form[k] = [form[k]];
        }
      }
      console.log('FORM', form);
      if (this.images) {
        form.Park_Images__c = JSON.stringify(this.images.map((img, index) => ({
          order: index,
          url: img.url,
          title: img.title,
        })));
      }
      return form;
    },
    async onSubmit(evt) {
      this.saving = true;
      this.loading = true;
      evt.preventDefault();
      window.scrollTo(0, 0);
      const payload = this.genForm();
      console.log({ payload });
      const saveResponse = await axios.post(`${server}/api/listing/${this.$route.params.id}`, payload);
      this.saved = true;
      console.log({ saveResponse });
      this.loading = false;
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.Account_Org_Address__c = null;
      this.form.Account_Org_City__c = null;
      this.form.Account_Org_Country__c = null;
      this.form.Account_Org_State__c = null;
      this.form.Account_Org_Zip_Postal__c = null;
      this.form.Account_Website__c = null;
      this.form.Amenities__c = null;
      this.form.Booking_Link__c = null;
      this.form.Close_Day__c = null;
      this.form.Close_Month__c = null;
      this.form.Clubs_Discounts__c = null;
      this.form.Directions_to_Park__c = null;
      this.form.Discounts__c = null;
      this.form.Extended_Stay__c = null;
      this.form.Facebook_Page__c = null;
      this.form.Instagram_URL__c = null;
      this.form.Is_Published__c = null;
      this.form.Lifestyles__c = null;
      this.form.Local_Points_of_Interest__c = null;
      this.form.Open_All_Year__c = null;
      this.form.Open_Day__c = null;
      this.form.Open_Month__c = null;
      this.form.Park_Classification__c = null;
      this.form.Park_Description__c = null;
      this.form.Park_Listing_Name__c = null;
      this.form.Park_Overview__c = null;
      this.form.Park_Phone__c = null;
      this.form.Park_Public_Email__c = null;
      this.form.Park_Rules__c = null;
      this.form.Plan_It_Green_Park__c = null;
      this.form.Rates__c = null;
      this.form.Recreation__c = null;
      this.form.Services__c = null;
      this.form.Site_Options__c = null;
      this.form.Toll_Free_Phone__c = null;
      this.form.Trip_Advisor__c = null;
      this.form.Twitter_Page__c = null;
      this.form.Yelp__c = null;
      this.form.You_Tube__c = null;
      this.form.Park_Images__c = null;
      this.form.Park_Lat_Long__c = {
        latitude: null,
        longitude: null,
      };

      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
  mounted() {
    this.$nextTick(async () => {
      try {
        const rawListings = await axios.get(`${server}/api/listing/${this.$route.params.id}`);
        if (rawListings.data.redirect) {
          window.location.href = rawListings.data.redirect;
          return;
        }
        console.log('Loading listing', rawListings);
        this.picklists = rawListings.data.picklists;
        this.picklists.Open_Day__c = this.picklists.Open_Day__c.reverse();
        this.picklists.Close_Day__c = this.picklists.Close_Day__c.reverse();
        // eslint-disable-next-line prefer-destructuring
        this.form = rawListings.data.queryResults.records[0];
        if (this.form.Park_Lat_Long__c === null) {
          this.form.Park_Lat_Long__c = {
            latitude: null,
            longitude: null,
          };
        }
        this.form.Park_Description__c = this.form.Park_Description__c || '';
        this.form.Directions_to_Park__c = this.form.Directions_to_Park__c || '';
        this.form.Local_Points_of_Interest__c = this.form.Local_Points_of_Interest__c || '';
        this.form.Park_Rules__c = this.form.Park_Rules__c || '';
        this.form.Rates__c = this.form.Rates__c || '';
        Object.keys(this.picklists).forEach((key) => {
          if (this.form[key]) {
            this.form[key] = this.picklists[key].filter((x) => this.form[key].includes(x.value));
          }
        });
        this.slug = rawListings.data.slug;
        this.newgcaurl = rawListings.data.newgcaurl;
        if (this.form.Park_Images__c) {
          this.setImages(JSON.parse(this.form.Park_Images__c));
        }
        this.loading = false;
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 200);
      } catch (err) {
        console.log({ listListingsError: err });
        this.loadingMessage = 'There was an issue pulling your listing. Please let us know so we can take a look!';
      }
    });
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
  .view-listing-link {
    display: block;
    text-align: right;
    position: relative;
    top: 36px;
    right: 24px;
    z-index: 2;
  }
  .ql-tooltip.ql-editing {
    z-index: 9;
  }
</style>
